import { ReactNode } from "react";

import { LogoSlackColored } from "components/icons/generated";
import setLocation from "shared/setLocation";
import { FederationProvider } from "types/generated";

import ConnectionCard from "../ConnectionCard";
import { PersonalConnectionsFederation } from "../gql";
import useExternalAccountsConnectionFeedback from "../useConnectionFeedback";
import {
  SLACK_LINK_ERROR_MESSAGES,
  SLACK_LINK_GENERIC_ERROR,
  SLACK_LINK_START_PATH,
  SLACK_NO_WORKSPACE_ERROR_CODE,
} from "./constants";
import NoWorkspaceError from "./NoWorkspaceError";

const SLACK_DESCRIPTION =
  "Connect your Slack account to receive run notifications and alerts directly in your Slack workspace.";

type ExternalAccountsSlackCardProps = {
  federation?: PersonalConnectionsFederation;
};

const ExternalAccountsSlackCard = ({ federation }: ExternalAccountsSlackCardProps) => {
  const { errorMessage, errorCode } = useExternalAccountsConnectionFeedback({
    statusParam: "slack_link",
    errorParam: "slack_link_error",
    successMessage: "Slack successfully linked.",
    errorMessages: SLACK_LINK_ERROR_MESSAGES,
    genericError: SLACK_LINK_GENERIC_ERROR,
  });

  // Codes needing richer banner content than their plain message; anything else uses the message as-is.
  const errorBanners: Record<string, ReactNode> = {
    [SLACK_NO_WORKSPACE_ERROR_CODE]: <NoWorkspaceError message={errorMessage} />,
  };

  const richBanner = errorCode ? errorBanners[errorCode] : undefined;

  return (
    <ConnectionCard
      icon={LogoSlackColored}
      name="Slack"
      provider={FederationProvider.SlackOauth}
      description={SLACK_DESCRIPTION}
      federation={federation}
      onConnect={() => setLocation(SLACK_LINK_START_PATH)}
      errorMessage={richBanner ?? errorMessage}
    />
  );
};

export default ExternalAccountsSlackCard;
